import { EAddressStatus } from "../../../constants";
import type { TranslationFn } from "../../../types";
import {
  badgeColorMap,
  borderColorMap,
  type TBadgeColor,
  type IRadioOption,
} from "./address-list.interface";

export const getAddressBadgeTitle = (
  status: string | undefined,
  isSelected: boolean,
  t: TranslationFn,
): string => {
  const badgeTitleMap: Record<string, string> = {
    unverified: t("addressJourney.status.unverified"),
    default: t("addressJourney.status.default"),
  };

  if (status && status in badgeTitleMap) {
    return badgeTitleMap[status];
  }

  return isSelected ? t("addressJourney.status.selected") : "";
};

export const getAddressBadgeBorderColor = (
  isSelected: boolean,
  status?: string,
): string => {
  if (status === EAddressStatus.UNVERIFIED.toString()) {
    return borderColorMap.unverified;
  }

  if (isSelected && status === EAddressStatus.OTHER.toString()) {
    return borderColorMap.selected;
  }

  return borderColorMap.default;
};

export const getAddressOptionInfo = (
  option: IRadioOption,
  selectedValue: string,
  t: TranslationFn,
): {
  label: string | JSX.Element;
  value: string;
  status: EAddressStatus;
  badgeColor: TBadgeColor;
  badgeTitle: string;
} => {
  const { label, value } = option;
  const status = option.status?.toLowerCase() as EAddressStatus;
  const isSelected = value === selectedValue;

  const badgeColor = badgeColorMap[status];
  const badgeTitle = getAddressBadgeTitle(status, isSelected, t);

  return {
    label,
    value,
    status,
    badgeColor,
    badgeTitle,
  };
};
